"use strict";

var _slicedToArray = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var i18n_1 = __importDefault(require("../../i18n"));

var area_filter_1 = require("./area-filter");

var SubareaFilter = /*#__PURE__*/function () {
  function SubareaFilter() {
    _classCallCheck(this, SubareaFilter);
  }

  _createClass(SubareaFilter, null, [{
    key: "makeFilter",
    value: function makeFilter(keyword) {
      if (keyword) {
        var _keyword$split = keyword.split('|'),
            _keyword$split2 = _slicedToArray(_keyword$split, 2),
            areaRaw = _keyword$split2[0],
            subareaRaw = _keyword$split2[1];

        var area = area_filter_1.AreaFilter.makeFilter(areaRaw);
        var subarea = i18n_1.default.t("url.subarea.".concat(subareaRaw), {
          defaultValue: subareaRaw
        });
        return "".concat(area, "-subarea-").concat(subarea);
      }

      return '';
    }
  }, {
    key: "parseFilter",
    value: function parseFilter(urlToParse) {
      var subareaSplit = urlToParse.split('-subarea-');
      var subarea = subareaSplit[1] ? i18n_1.default.t("url-vuelta.subarea.".concat(subareaSplit[1]), {
        defaultValue: subareaSplit[1]
      }) : undefined;

      if (subarea) {
        var area = area_filter_1.AreaFilter.parseFilter(subareaSplit[0]);
        subarea = "".concat(area.result, "|").concat(subarea);
      }

      return {
        url: subareaSplit[0],
        result: subarea
      };
    }
  }]);

  return SubareaFilter;
}();

exports.SubareaFilter = SubareaFilter;